import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from 'react-router-dom';

import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import {formatDate} from '../../utils/helper.js';
import {statusColor} from "../../assets/utils/statusColors";
import Paginator from "../../components/Paginator"; 

const OrderDetails = () => {
 
  const { id } = useParams();
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({});
  const [orders, setOrders] = useState([]);
  const [logs, setLogs] = useState([]);

  const [isLoader, setIsLoader] = useState(false);
  const [currency] = useState(process.env.REACT_APP_CURRENCY);
  const [tab, setTab] = useState("info");
  const [branch, setBranch] = useState([]);
  const [timings, setTiming] = useState(null);
  const [apiData, setApiData] = useState({
        search: "",
        daterange: "",
        page: 1,
        branch_id: id,
        type:'',
        status:''
    });

  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);

  const getSingleData = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `branches/${id}`,
      });
      const data = response.data;
      if (data.status) {
        const item = data.data;
        setBranch(item.branch);
        setTiming(item.timings);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
    }
  };

  const getOrders = async () => {
      try {
          setIsLoader(true);
          const response = await ApiService.request({
              method: "GET",
              url: "orders", // Replace with your API endpoint
              data: apiData
          });
          const data = response.data;
          if (data.status) {
              setOrders(data.data);
              setPagination(data.pagination);
          } else {
              toast.error(data.message);
          }
          setIsLoader(false);
      } catch (error) {
          setIsLoader(false);
      }
      
  };

  const getActivityLogs = async () => {
      try {
          setIsLoader(true);
          const response = await ApiService.request({
              method: "GET",
              url: "getActivityLogs", // Replace with your API endpoint
              data: {entityType:"Branch", entityId:id, page:apiData.page}
          });
          const data = response.data;
          if (data.status) {
              setLogs(data.data.logs);
              setPagination(data.data.pagination);
          } else {
              toast.error(data.message);
          }
          setIsLoader(false);
      } catch (error) {
          setIsLoader(false);
      }
      
  };

  useEffect(() => {
    if (tab === "orders") {
      getOrders();
    }
    if (tab === "logs") {
      getActivityLogs();
    }
  }, [tab]);

  
  const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
  };


  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-flex flex-stack"
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              Branch: {branch?.name}
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <a href="/dashboard" className="text-muted text-hover-primary">
                  Dashboard
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <a href="/branches" className="text-muted text-hover-primary">
                  Branches
                </a>
              </li>
            </ul>
          </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3">
                <button type="button" className="btn btn-sm btn-secondary me-3" onClick={() => navigate(-1)}>
                    <i className="bi bi-arrow-left-short fs-1"></i>  Back
                </button>
            </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-5">

                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button  className={`nav-link fs-6 px-5 ${tab === "info" ? "active" : ""}`}
                            onClick={() => setTab("info")}
                     type="button"> <i className="bi bi-building-fill fs-5"></i>  Info</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button className={`nav-link fs-6 px-5 ${tab === "timings" ? "active" : ""}`}
                            onClick={() => setTab("timings")}
                      type="button" ><i className="bi bi-clock-fill fs-5"></i> Timings</button>
                  </li>

                  <li class="nav-item" role="presentation">
                    <button className={`nav-link fs-6 px-5 ${tab === "orders" ? "active" : ""}`}
                            onClick={() => setTab("orders")}
                      type="button" ><i className="bi bi-box-fill fs-5"></i> Orders</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button className={`nav-link fs-6 px-5 ${tab === "logs" ? "active" : ""}`}
                            onClick={() => setTab("logs")}
                      type="button" ><i className="bi bi-clipboard-data-fill fs-5"></i> Audit Logs</button>
                  </li>

                 
                </ul>

                {!isLoader && 
                  <div class="tab-content" id="myTabContent">
                    {tab === "info" && (
                      <div class="tab-pane fade show active" >
                        <div className="table-responsive mt-5 w-lg-75">
                          <table className="table align-middle table-striped bbranch fs-6">
                            <tbody>
                              <tr>
                                <th className="px-3 fw-semibold">Branch Name</th>
                                <th>{branch?.name}</th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Email</th>
                                <td> {branch?.email}</td>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Phone</th>
                                <td> {branch?.phone}</td>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Delivery Radius</th>
                                <td> {branch?.delivery_radius} Km</td>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Delivery Charges</th>
                                <td> {branch?.delivery_charges}  AED</td>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Delivery Time </th>
                                <td> {branch?.delivery_time} mins</td>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Delivery:</th>
                                <td>  <span className={branch?.is_delivery?'badge badge-success':'badge badge-danger'}>{branch?.is_delivery?'Yes':'No'}</span>  </td>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Pickup:</th>
                                <td>  <span className={branch?.is_pickup?'badge badge-success':'badge badge-danger'}>{branch?.is_pickup?'Yes':'No'}</span>  </td>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Location</th>
                                <td> {branch?.location}</td>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Registered DateTime</th>
                                <td>{formatDate(branch?.createdAt,'DD MMM, hh:mm A')} </td>
                              </tr>
                            
                            
                            </tbody>
                          
                          </table>
                        </div>
                      </div>
                    )}
                    {tab === "timings" && (
                      <div class="tab-pane fade show active">
                        <div className="table-responsive mt-5 w-lg-75">
                          <table className="table align-middle table-striped bbranch fs-6">
                            <tbody>
                              <tr>
                                <th className="px-3 fw-semibold">Day</th>
                                <th className="px-3 fw-semibold">Open Time</th>
                                <th className="px-3 fw-semibold">Close Time</th>
                                <th className="px-3 fw-semibold">Is Off</th>
                              </tr>
                              {timings  ? timings.map((item, index) => (
                                <tr key={index}>
                                 

                                  <td>{item.day ?? '--'}</td>
                                  <td>{item.open ?? '--'}</td>
                                  <td>{item.close ?? '--'}</td>
                                  <td>{item.is_off?'Yes':'No'}</td>
                                </tr>
                              )) : (
                                  <tr>
                                      <td colSpan="6" className="text-dark text-center mt-2">No data found!</td>
                                  </tr>
                              )}

                             
                            </tbody>
                          
                          </table>
                        </div>
                      </div>
                    )}

                  

                    {tab === "orders" && (
                      <div class="tab-pane fade show active">
                            <div className="table-responsive">
                                <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                    <thead>
                                        <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                            <th>Order #</th>
                                            <th>User</th>
                                            <th>Pay Method</th>
                                            <th>Order Total</th>
                                            <th>Order Type</th>
                                            <th>Status</th>
                                            <th>Order Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600 fs-6">
                                        {orders.length > 0 ? orders.map((item, index) => (
                                            <tr key={index}>
                                                <td>#{item.order_code}</td>

                                                <td>
                                                    {item.user && 
                                                        <div>
                                                            {item.user.name} <br />
                                                            {item.user.phone}
                                                        </div>
                                                    }
                                                </td>
                                                <td> {item.payment_method}</td>
                                                <td> {currency} {item.grand_total.toFixed(2)}</td>
                                                <td> {item.type}</td>

                                                <td>
                                                    <button className="p-0 btn btn-transparent">
                                                        <span className={`badge bg-${statusColor[item.status]}`}  >
                                                            {item.status }
                                                        </span>
                                                    </button>
                                                </td>
                                                <td>  {formatDate(item.createdAt,'DD MMM YYYY, hh:mm A')} </td>
                                                <td className="mt-2">
                                                    <Link to={`/orders/${item._id}`} className="btn btn-sm h-35px btn-light-primary">
                                                        <i className="bi bi-eye-fill fs-6"></i>
                                                    </Link>
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan="11" className="text-dark text-center mt-2">No data found!</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table> 
                                {isLoader && (
                                    <Loader text="Loading" size="30" className="text-center"  />
                                )}
                                <span>Total Records: {pagination?.total_records}</span>


                                {pagination.total_pages > 1 && (
                                    <Paginator
                                        page={pagination.current_page}
                                        rows={pagination.per_page}
                                        totalRecords={pagination.total_records}
                                        onPageChange={handlePageChange}
                                    />
                                )}
                            </div>
                      </div>
                    )}
                    
                    {tab === "logs" && (
                      <div class="tab-pane fade show active">
                            <div className="table-responsive">
                                <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                    <thead>
                                        <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                            <th>User</th>
                                            <th>Action</th>
                                            <th>Changes</th>
                                            <th>DateTime</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600 fs-6">
                                        {logs.length > 0 ? logs.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {item.user_id && 
                                                        <div>
                                                            {item.user_id.name} <br />
                                                            {item.user_id.email}
                                                        </div>
                                                    }
                                                </td>
                                                <td> {item.action}</td>

                                                <td> 
                                                   <div className="changes-container">
                                                    {item.changes?.map((change, index) => (
                                                      <div key={index} className="change-item mb-2 p-2 border rounded">
                                                        <div className="font-weight-bold text-capitalize">{change.field}</div>
                                                        <div className="d-flex justify-content-between">
                                                          <div className="old-value pr-2">
                                                            <span className="text-muted small">Old:</span>
                                                            <div className="value-box bg-light p-1">
                                                              {JSON.stringify(change.oldValue)}
                                                            </div>
                                                          </div>
                                                          <div className="new-value pl-2">
                                                            <span className="text-muted small">New:</span>
                                                            <div className="value-box bg-light p-1">
                                                              {JSON.stringify(change.newValue)}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ))}
                                                  </div>
                                                  
                                                </td>
                                                <td>  {formatDate(item.createdAt,'DD MMM YYYY, hh:mm A')} </td>

                                                {/* <td className="mt-2">
                                                    <Link to={`/orders/${item._id}`} className="btn btn-sm h-35px btn-light-primary">
                                                        <i className="bi bi-eye-fill fs-6"></i>
                                                    </Link>
                                                </td> */}
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan="11" className="text-dark text-center mt-2">No data found!</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table> 
                                {isLoader && (
                                    <Loader text="Loading" size="30" className="text-center"  />
                                )}
                                <span>Total Records: {pagination?.total_records}</span>


                                {pagination.total_pages > 1 && (
                                    <Paginator
                                        page={pagination.current_page}
                                        rows={pagination.per_page}
                                        totalRecords={pagination.total_records}
                                        onPageChange={handlePageChange}
                                    />
                                )}
                            </div>
                      </div>
                    )}


                  </div>
                }
                {isLoader && 
                  <Loader color="black" className="mt-5" text="Loading" size="30" />
                }
             
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
